import React, { FC, memo } from 'react';
import { IDataGridColumnEditorNumber } from '../../../model';
import { Controller, useForm } from 'react-hook-form';
import { TextField } from '@mui/material';
import { ClickAwayListener } from '@mui/material';
import Footer from './footer';
import { useI18n } from 'AurionCR/components';
import { validateRule } from 'AurionCR/components/formV2';

const EditorNumber: FC<
  React.PropsWithChildren<{
    editor: IDataGridColumnEditorNumber;
    data: string;
    onClose: any;
    onSubmit: any;
  }>
> = ({ editor, data, onClose, onSubmit }) => {
  const { t } = useI18n();
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({ defaultValues: { data: data || 0 } }) as any;
  return (
    <ClickAwayListener onClickAway={onClose}>
      <div className="grid-editor string">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                autoFocus
                type="number"
                error={Boolean(errors.data)}
                // @ts-ignore
                helperText={errors.data ? t(errors.data.message) : ''}
              />
            )}
            name="data"
            control={control}
            rules={editor.required ? validateRule('required') : {}}
          />
          <Footer onClose={onClose} />
        </form>
      </div>
    </ClickAwayListener>
  );
};

export default memo(EditorNumber);
